var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M473.651,88.257H38.292c-20.485,0-37.215,16.06-38.292,36.277v47.595h512v-45.522 C512,105.427,494.831,88.257,473.651,88.257z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 172.119,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 83.87
  }), /*#__PURE__*/React.createElement("rect", {
    y: 255.999,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 83.87
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M0,387.466c1.077,20.215,17.807,36.277,38.292,36.277h435.359c21.18,0,38.349-17.169,38.349-38.349 v-45.522H0V387.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.668,252.486L13.669,97.213C5.775,103.833,0.584,113.57,0,124.534v262.933 c0.584,10.964,5.775,20.701,13.669,27.321l236.999-155.275C253.198,257.854,253.198,254.145,250.668,252.486z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M48.839,256c0-31.923,20.867-58.934,49.695-68.237c1.515-0.489,1.304-2.702-0.275-2.908 c-2.968-0.388-5.99-0.598-9.065-0.598c-39.623,0-71.743,32.121-71.743,71.743s32.121,71.743,71.743,71.743 c3.075,0,6.097-0.21,9.065-0.598c1.579-0.207,1.79-2.419,0.275-2.908C69.706,314.934,48.839,287.923,48.839,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M98.901,201.202l1.975,5.922l6.242,0.049c0.808,0.007,1.143,1.037,0.493,1.517l-5.021,3.708 l1.883,5.952c0.244,0.77-0.633,1.408-1.291,0.938l-5.079-3.63l-5.079,3.63c-0.658,0.47-1.535-0.168-1.291-0.938l1.883-5.952 l-5.021-3.708c-0.65-0.48-0.315-1.512,0.493-1.517l6.242-0.049l1.975-5.922C97.56,200.435,98.645,200.435,98.901,201.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M98.901,231.212l1.975,5.922l6.242,0.049c0.808,0.007,1.143,1.037,0.493,1.517l-5.021,3.708 l1.883,5.952c0.244,0.77-0.633,1.408-1.291,0.938l-5.079-3.63l-5.079,3.63c-0.658,0.47-1.535-0.168-1.291-0.938l1.883-5.952 l-5.021-3.708c-0.65-0.48-0.315-1.512,0.493-1.517l6.242-0.049l1.975-5.922C97.56,230.445,98.645,230.445,98.901,231.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M98.901,261.221l1.975,5.922l6.242,0.049c0.808,0.007,1.143,1.037,0.493,1.517l-5.021,3.708 l1.883,5.952c0.244,0.77-0.633,1.408-1.291,0.938l-5.079-3.63l-5.079,3.63c-0.658,0.47-1.535-0.168-1.291-0.938l1.883-5.952 l-5.021-3.708c-0.65-0.48-0.315-1.512,0.493-1.517l6.242-0.049l1.975-5.922C97.56,260.454,98.645,260.454,98.901,261.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M98.901,291.229l1.975,5.922l6.242,0.049c0.808,0.007,1.143,1.037,0.493,1.517l-5.021,3.708 l1.883,5.952c0.244,0.77-0.633,1.408-1.291,0.938l-5.079-3.63l-5.079,3.63c-0.658,0.47-1.535-0.168-1.291-0.938l1.883-5.952 l-5.021-3.708c-0.65-0.48-0.315-1.512,0.493-1.517l6.242-0.049l1.975-5.922C97.56,290.464,98.645,290.464,98.901,291.229z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.e0df5367abccb9f40940a3749f43a0c2.svg";
export { ForwardRef as ReactComponent };